import { Component, OnInit, NgZone } from '@angular/core';
import { TitleService } from '@app/shared/services/title.service';
import { MenuService } from '@app/shared/services/menu.service';
import * as moment from 'moment/moment';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { SocietiesService } from '@app/shared/services/societies.service';
import { ExcelService } from '@app/shared/services/excel.service';
import { SessionService } from '@app/shared/services/session.service';
import { DateService } from '@app/shared/services/date.service';
import { UsersService } from '@app/shared/services/users.service';
import { ActivatedRoute } from '@angular/router';
import { AlertService } from '@app/shared/services/alert.service';

import { RESERVATION_STATUS_NAMES } from '@app/shared/constants/reservation-status';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from "rxjs/internal/operators";

@Component({
    selector: 'app-reservation-me',
    templateUrl: './reservation-me.component.html',
    styleUrls: ['./reservation-me.component.scss']
})
export class MyReservationComponent implements OnInit {

    /* Session */

    private sessionStatusNames = RESERVATION_STATUS_NAMES;

    /* Datepicker */

    public dateStart: string = moment().subtract(31, 'days').format('DD/MM/YYYY').split('T')[0];
    public dateEnd: string = moment().add(10, 'days').format('DD/MM/YYYY').split('T')[0];
    public dateStartChanged: Subject<string> = new Subject<string>();
    public dateEndChanged: Subject<string> = new Subject<string>();

    /* Filters */

    public pickerReservation: any;
    public status: number = 0;
    public search: string = 'VERGNE YOHAN';
    public searchChanged: Subject<string> = new Subject<string>();
    public societySearch: string = '';
    // public societySelected: number = 0;
    // public societyOptions: any = [];
    // public societyDisplay: boolean = false;
    // public societyNoResult: boolean = false;
    // public societyLoading: boolean = false;
    // public _timeout: any = null;

    /* List */

    public reservations: Array<any> = [];
    public comeUp: Array<any> = [];
    public inProgress: Array<any> = [];
    public finished: Array<any> = [];
    public canceled: Array<any> = [];
    public maxPages: number = 1;
    public currentPage: number = 1;
    public loadingStatus: boolean = true;
    public noResult: boolean = false;
    public excelLoading: boolean = false;

    constructor(
        private titleService: TitleService,
        private menu: MenuService,
        private reservationService: ReservationsService,
        private excelService: ExcelService,
        private route: ActivatedRoute,
        public session: SessionService,
        private dateService: DateService,
        private userService: UsersService,
        private alertService: AlertService
    ) {
        this.searchChanged
            .pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe(model => {
                this.search = model;
                this.currentPage = 1;
                sessionStorage.setItem('ReservationFilterSearch', model);
                this.updateReservations();
            });

        this.dateStartChanged
            .subscribe(model => {
                this.dateStart = model;
                this.currentPage = 1;
                sessionStorage.setItem('ReservationFilterDateStart', model);
                this.updateReservations();
            });

        this.dateEndChanged
            .subscribe(model => {
                this.dateEnd = model;
                this.currentPage = 1;
                sessionStorage.setItem('ReservationFilterDateEnd', model);
                this.updateReservations();
            });
    }

    retrieveFilters() {
        this.search = ('ReservationFilterSearch' in sessionStorage) ? sessionStorage.getItem('ReservationFilterSearch') : this.search;
        this.dateStart = ('ReservationFilterDateStart' in sessionStorage) ? sessionStorage.getItem('ReservationFilterDateStart') : this.dateStart;
        this.dateEnd = ('ReservationFilterDateEnd' in sessionStorage) ? sessionStorage.getItem('ReservationFilterDateEnd') : this.dateEnd;
        this.status = ('ReservationFilterStatus' in sessionStorage) ? parseInt(sessionStorage.getItem('ReservationFilterStatus'), 10) : this.status;
    }

    ngOnInit() {
        this.route.queryParams
            .subscribe(params => {
                if (params.vehicule) {
                    this.search = params.vehicule;
                    sessionStorage.setItem('ReservationFilterSearch', params.vehicule);
                    this.updateReservations();
                }
            });

        this.titleService.setTitle(`Liste des réservations / VOP`);
        this.menu.setMenuState('reservation', 'reservation', '');
        this.retrieveFilters();
        if ('ReservationList' in sessionStorage
            && moment(sessionStorage.getItem('ReservationListTimeout')).isBetween(moment().subtract(2, 'minute'), moment())) {
            this.reservations = JSON.parse(sessionStorage.getItem('ReservationList'));
            this.maxPages = parseInt(sessionStorage.getItem('ReservationListMaxPages'), 10);
            this.currentPage = parseInt(sessionStorage.getItem('ReservationListCurrentPage'), 10);
            this.sortReservationsByStatus();
            this.sortReservationsByDate();
            this.getStaffStatus();
            this.getFinishedInvoiceFields();
            this.loadingStatus = false;
        } else {
            this.initReservations(0);
        }
    }

    changeStatus(status): void {
        this.status = status;
        sessionStorage.setItem('ReservationFilterStatus', this.status.toString());
        this.updateReservations();
    }

    onSearchChange(search): void {
        this.searchChanged.next(search);
    }

    onDateChange(start, date): void {
        if (start === true) {
            this.dateStartChanged.next(date);
        } else {
            this.dateEndChanged.next(date);
        }
    }

    setReservations(res): void {
        res = this.dateService.convertAlltoLocal(res);
        this.reservations = res;
        console.log("session: ", this.session)
        sessionStorage.setItem('ReservationList', JSON.stringify(this.reservations));
        sessionStorage.setItem('ReservationListMaxPages', this.maxPages.toString());
        sessionStorage.setItem('ReservationListCurrentPage', this.currentPage.toString());
        sessionStorage.setItem('ReservationListTimeout', moment().format());
        this.sortReservationsByStatus();
        this.sortReservationsByDate();
        this.getStaffStatus();
        this.getFinishedInvoiceFields();
    }

    sortReservationsByStatus(): void {
        this.comeUp = [];
        this.inProgress = [];
        this.finished = [];
        this.canceled = [];
        this.reservations.forEach((reservation) => {
            if (reservation.Status === -1) {
                this.canceled.push(reservation);
            }
            if (reservation.Status >= 0 && reservation.Status <= 2) {
                this.comeUp.push(reservation);
            }
            if (reservation.Status >= 3 && reservation.Status <= 10) {
                this.inProgress.push(reservation);
            }
            if (reservation.Status >= 11 && reservation.Status <= 14) {
                this.finished.push(reservation);
            }
        });
    }

    sortReservationsByDate(): void {
        [this.finished, this.comeUp, this.inProgress, this.canceled].forEach((reservationList) => {
            reservationList.sort((a, b) => {
                if (a.ISODateStart > b.ISODateStart)
                    return -1;
                if (a.ISODateStart < b.ISODateStart)
                    return 1;
                return 0;
            });
        });
    }

    getFinishedInvoiceFields(): void {
        this.finished.forEach((reservation, index) => {
            this.reservationService.getReservationInvoiceFields(reservation.Id).then((res) => {
                reservation.totalAmount = 0;
                if (res && res.length > 0) {
                    res.forEach((line) => {
                        reservation.totalAmount += line.IncludingTaxes * line.Quantity;
                    });
                }
            });
        });
    }

    getStaffStatus(): void {
        [this.finished, this.comeUp, this.inProgress, this.canceled].forEach((reservationList) => {
            reservationList.forEach((reservation) => {
                reservation.loading = true;
                this.userService.getUser(reservation.IdAccount).then((user) => {
                    reservation.CodeSociety = user.CodeSociety;
                    if (user.IdAccountDemo > 0) {
                        reservation.demo = true;
                    } else {
                        reservation.demo = false;
                    }
                    reservation.loading = false;
                });
            });
        });
    }

    initReservations(next) {
        if (next === 390) {
            return;
        }

        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.search, this.societySearch
        ).then((res) => {
            console.log(res);
            console.log(this.session.role)
            if (this.session.role.ability == 'user') {
                res = res.filter(r => r.IdAccount == "263");
            }

            this.maxPages = this.reservationService.maxPages;
            if (res.length === 0) {
                this.noResult = true;
                this.dateStart = moment().subtract(next + 30, 'days').format('DD/MM/YYYY').split('T')[0];
                this.dateEnd = moment().subtract(next, 'days').format('DD/MM/YYYY').split('T')[0];
                this.initReservations(next + 30);
            } else {
                this.loadingStatus = false;
                this.noResult = false;
                this.setReservations(res);
            }
        });
    }

    updateReservations() {
        this.loadingStatus = true;
        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.search, this.societySearch
        ).then((res) => {
            console.log(res);
            console.log(this.session.role)
            if (this.session.role.ability == 'user') {
                res = res.filter(r => r.IdAccount == "263");
            }

            this.maxPages = this.reservationService.maxPages;
            this.loadingStatus = false;
            if (res.length === 0) {
                this.noResult = true;
            } else {
                this.noResult = false;
                this.setReservations(res);
            }
        });
    }

    nextPage() {
        if (this.currentPage < this.reservationService.maxPages) {
            this.loadingStatus = true;
            this.currentPage += 1;
            this.reservationService.updateReservationByDate(
                moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
                moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
                this.currentPage, this.status, this.search, this.societySearch
            ).then((res) => {
                console.log(res);
                console.log(this.session.role)
                if (this.session.role.ability == 'user') {
                    res = res.filter(r => r.IdAccount == "263");
                }

                this.maxPages = this.reservationService.maxPages;
                this.loadingStatus = false;
                if (res.length === 0) {
                    this.noResult = true;
                } else {
                    this.noResult = false;
                    this.setReservations(res);
                }
            });
        }
    }

    goPage(page): any {
        this.loadingStatus = true;
        this.currentPage = page;
        sessionStorage.setItem('ReservationFilterCurrentPage', this.currentPage.toString());
        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            this.currentPage, this.status, this.search, this.societySearch
        ).then((res) => {
            console.log(res);
            console.log(this.session.role)
            if (this.session.role.ability == 'user') {
                res = res.filter(r => r.IdAccount == "263");
            }

            this.maxPages = this.reservationService.maxPages;
            this.loadingStatus = false;
            if (res.length === 0) {
                this.noResult = true;
            } else {
                this.noResult = false;
                this.setReservations(res);
            }
        });
    }

    prevPage() {
        if (this.currentPage > 1) {
            this.loadingStatus = true;
            this.currentPage -= 1;
            this.reservationService.updateReservationByDate(
                moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
                moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
                this.currentPage, this.status, this.search, this.societySearch
            ).then((res) => {
                console.log(res);
                console.log(this.session.role)
                if (this.session.role.ability == 'user') {
                    res = res.filter(r => r.IdAccount == "263");
                }

                this.maxPages = this.reservationService.maxPages;
                this.loadingStatus = false;
                if (res.length === 0) {
                    this.noResult = true;
                } else {
                    this.noResult = false;
                    this.setReservations(res);
                }
            });
        }
    }

    // updateSocietyOptionList(event) {
    //     if (this._timeout) {
    //         window.clearTimeout(this._timeout);
    //     }
    //     this._timeout = window.setTimeout(() => {
    //         this._timeout = null;
    //         this.lc.run(() => {
    //             this.societySearch = event;
    //             this.societyLoading = true;
    //             this.societyNoResult = false;
    //             this.societyService.updateSocieties(1, this.societySearch).then((res) => {
    //                 if (res.length > 0) {
    //                     this.societyOptions = res;
    //                 } else {
    //                     this.societyNoResult = true;
    //                 }
    //                 this.societyLoading = false;
    //             });
    //             this.initReservations(0);
    //         });
    //     }, 1000);
    // }

    // setSocietySearch(option) {
    //     this.societySearch = option.Code;
    //     this.societySelected = option.Id;
    //     this.initReservations(0);
    // }

    // toggleSuggestions(shouldDisplay) {
    //     setTimeout(() => {
    //         this.societyDisplay = shouldDisplay;
    //     }, 250);
    // }

    exportDataAsXLSX(): any {
        let datas = [];
        let cols = this.excelService.initCols(["Code réservation", "Utilisateur", "Véhicule", "Date de début",
            "Date de fin", "Date de début réelle", "Date de fin réelle", "Distance parcourue", "Status"]);

        this.excelLoading = true;
        this.reservationService.updateReservationByDate(
            moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
            moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
            1, this.status, this.search, this.societySearch
        ).then(async () => {
            this.maxPages = Math.max(this.reservationService.maxPages, 1);
            for (let i = 1; i <= this.maxPages; i++) {
                let results = await this.reservationService.updateReservationByDate(
                    moment(this.dateStart, 'DD/MM/YYYY').format().split('T')[0],
                    moment(this.dateEnd, 'DD/MM/YYYY').format().split('T')[0],
                    i, this.status, this.search, this.societySearch
                );

                if (results.length == 0) {
                    this.excelLoading = false;
                    return this.alertService.alert("Aucune donnée à exporter");
                }

                results.forEach((result) => {
                    let data = {
                        "Code réservation": result.Code,
                        "Utilisateur": result.User,
                        "Véhicule": result.Vehicle,
                        "Date de début": (result.ISODateStart.length !== 0) ? moment(result.ISODateStart).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                        "Date de fin": (result.ISODateEnd.length !== 0) ? moment(result.ISODateEnd).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                        "Date de début réelle": (result.ISORealDateStart.length !== 0) ? moment(result.ISORealDateStart).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                        "Date de fin réelle": (result.ISORealDateEnd.length !== 0) ? moment(result.ISORealDateEnd).format('DD/MM/YYYY à hh:mm A').split('T')[0] : '',
                        "Distance parcourue": result.DistanceTraveled,
                        "Status": this.sessionStatusNames[Math.min(result.Status, 14)],
                    };

                    Object.values(data).forEach((value, index) => {
                        if (typeof value === 'string') {
                            cols[index].wch = Math.max(value.length, cols[index].wch);
                        }
                    });
                    datas.push(data);
                });
            }
            cols = this.excelService.extendCols(cols);
            this.excelService.exportExcel(datas, "vop-reservations", cols);
            this.excelLoading = false;
        });
    }

}